import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import Button from 'components/ui/abstract/Button'

interface IArrowButtonProps {
  onClick: () => void,
  text: string,
  buttonStyle?: string,
}

const ArrowButton = ({
  buttonStyle,
  onClick,
  text,
}: IArrowButtonProps) => {
  const styles = StyleSheet.create({
    button: {
      transition: 'width 0.4s',
    },
    buttonContent: {
      textAlign: 'left',
      maxHeight: 32,
      minWidth: '100%',
    },
  })

  const btnStyles = [
    css(styles.button),
    buttonStyle,
  ]

  return (
    <Button
      onClick={onClick}
      classes={{
        root: btnStyles.join(' '),
      }}
      variant="contained"
    >
      <span className={css(styles.buttonContent)}>
        {text}
      </span>
    </Button>
  )
}
ArrowButton.defaultProps = {
  buttonStyle: null,
}
export default ArrowButton
